import { Ajuste } from '@/service/api'

export type NivelAjuste = 'centroCusto' | 'local' | 'funcionario' | 'data'

export const ORDEM_NIVEIS: readonly NivelAjuste[] = [
    'centroCusto',
    'local',
    'funcionario',
    'data',
] as const

export const LABEL_NIVEL: Record<NivelAjuste, string> = {
    centroCusto: 'Centro de custo',
    local: 'Local',
    funcionario: 'Funcionário',
    data: 'Data/Período',
}

export const CAMPO_POR_NIVEL: Record<NivelAjuste, string> = {
    centroCusto: '_centroCustoNome',
    local: '_localNome',
    funcionario: '_funcionarioNome',
    data: '_dataLabel',
}

export type { Ajuste }
